import React from "react";
import { Box, Typography } from "@mui/material";
import styles from './styles.module.css';

export default function BetsTable({ casinoBets = [], roundId }) {


const filteredBets = casinoBets;

    return (
        <Box className={styles.MatchScreen_container}>
            <Box className={styles.box_container}>

                {/* Header Row */}
                <Box className={styles.headerSelection_container}>
                    <Typography className={styles.Selection_txt}>Selection</Typography>
                    <Typography className={styles.OddsStake_txt}>Odds</Typography>
                    <Typography className={styles.OddsStake_txt}>Stake</Typography>
                </Box>

                {/* Empty State */}
                {filteredBets.length === 0 ? (
                    <Box sx={{ textAlign: 'center', padding: '16px' }}>
                        <Typography sx={{ color: '#888', fontSize: '13px' }}>
                            No bets placed this round
                        </Typography>
                    </Box>
                ) : (
                    filteredBets.map((bet, index) => (
                        <Box
                            key={bet.betId || index}
                            className={styles.betsSelection_container}
                        >
                            <Typography className={styles.betsSelection_txt}>
                                {bet.selection || bet.marketName || '-'}
                            </Typography>
                            <Typography className={styles.betsOddsStake_txt}>
                                {bet.rate ?? bet.odds ?? '-'}
                            </Typography>
                            <Typography className={styles.betsOddsStake_txt}>
                                {bet.stake ?? '-'}
                            </Typography>
                        </Box>
                    ))
                )}

            </Box>
        </Box>
    );
}